<div class="grid-container mat-elevation-z10">
    <div class="" fxLayout="row" fxLayoutAlign="space-between" style="padding: 10px 30px 30px">
      <h3>Commandi</h3>
    </div>
    <div class="" style="overflow-x: auto">
      <!--(matSortChange)="onTableClicked(data)" (matSortChange)="sortData($event)" row.delivery_category_item.type.tipologia {{getCellValue(row, column) }}-->
      <table mat-table [dataSource]="this.data"  aria-describedby="events tables">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ "smart-bin-commands.grid.column.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.name }}
            </td>
        </ng-container>
        <ng-container matColumnDef="payload_size">
            <th mat-header-cell *matHeaderCellDef>
              {{ "smart-bin-commands.grid.column.payload_size"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.payload_size }}
            </td>
        </ng-container>
        <ng-container matColumnDef="payload">
          <th mat-header-cell *matHeaderCellDef>
            {{ "smart-bin-commands.grid.column.payload"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.payload }}
          </td>
        </ng-container>
        <ng-container matColumnDef="payload_hex">
          <th mat-header-cell *matHeaderCellDef>
            {{ "smart-bin-commands.grid.column.payload_hex"  | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.payload_hex }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
        <tr class="mat-row w-100" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="mat-cell mat-cell-no-data text-center">
          </td>
        </tr>
      </table>
    </div>
</div>

